
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payments/plans/promo-special/new",
      function () {
        return require("private-next-pages/payments/plans/promo-special/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payments/plans/promo-special/new"])
      });
    }
  